<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ previousRoom ? $t('edit_room') : $t('add_room') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-6
      .text-md.font-semibold.neutral700--text {{ $t('fill_the_information_below') }}
      v-form(ref="form")
        .mb-4.mt-4
          .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('choose_room') }}
          y-select(v-if="previousRoom" v-model="selectedRoom" item-text="name" item-value="id" :items="rooms" disabled)
          rooms-dropdown(v-else v-model="selectedRoom")
        .mb-4
          .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('display_name') }}
          v-text-field.round-xl(v-model="displayName" :placeholder="$t('enter_display_name')" outlined dense height="48" counter="14")

    v-divider
    v-card-actions.py-3.px-6
      y-button.px-0(:label="$t('cancel')" @click="showDialog = false" underline)
      v-spacer
      y-button(:label="$t('confirm')" @click="confirm" :loading="isLoading" :disabled="isFetching || !displayName || !selectedRoom")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RoomsDropdown from '@/components/clinic/custom/RoomsDropdown.vue'

export default {
  components: { RoomsDropdown },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    previousRoom: {
      type: Object,
    }
  },
  data: () => ({
    selectedRoom: null,
    displayName: null,
    rooms: [],
    isFetching: false,
    isLoading: false,
    disableSelect: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchRooms()
    if (this.previousRoom) {
      this.selectedRoom = this.previousRoom.id
      this.displayName = this.previousRoom.qtv_display_name
      this.disableSelect = true
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchRooms () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/facilities?type=room&page_size=-1&fields=id,name`)
        .then(resp => {
          this.rooms = resp.data.results
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    confirm () {
      this.isLoading = true
      this.$axios.patch(`/clinics/${this.company.slug}/facilities/${this.selectedRoom}`, { qtv_display_name: this.displayName })
        .then(resp => {
          this.$emit('onUpdated', resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>